// ----------------------------------------------------------------------
// <copyright file="Izenda.CopyReport.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var EventsUtils = require('EventUtils');
  var Validator = require('share/components/hoc/Izenda.Validator');
  var MobxUtils = require('share/utils/Izenda.MobxUtils');
  var connect = require('share/enhancers/Izenda.Connect');
  var m = require('mobx');
  var AppStore = require('logic/Izenda.AppStore');

  var action = require('./Izenda.CopyReportAction');
  var constants = require('logic/data/Izenda.ReportsConstants');
  var CategoryDetail = require('logic/models/Izenda.CategoryDetail');
  var REPORT_DESIGNER_CONSTANTS = require('logic/data/Izenda.ReportDesignerConstants');

  var Popup = require('share/components/controls/CommonPopup/Izenda.Popup');
  var Select = require('share/components/controls/multiSelectBox/Izenda.Select');
  var ValidatableInput = Validator()(require('share/components/controls/Izenda.Input'));
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Label = require('share/components/controls/Izenda.Label');
  var Dropdown = require('share/components/controls/Izenda.DropDown');
  const { map, cloneDeep, isEmpty } = require('lodash/fp');

  function preventAddNew() {
    return false;
  }

  var CopyReport = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired,
      onClose: React.PropTypes.func
    },

    getDefaultProps: function() {
      return {
        version: 0
      };
    },

    componentDidMount: function() {
      var props = this.props;
      var store = props.store;

      Promise.join(
        AppStore.loadCategorySettings(),
        store.loadCategoriesForCopyPopup(store.reportType, props.saveInto),
        m.action(function(categorySetting, result) {
          var saveIntos = map(function(item) {
            return {
              value: item.isGlobal
                ? REPORT_DESIGNER_CONSTANTS.GLOBAL_REPORT_ENUM.GLOBAL
                : REPORT_DESIGNER_CONSTANTS.GLOBAL_REPORT_ENUM.LOCAL,
              name: item.name
            };
          }, categorySetting);
          props.updateSaveIntos(saveIntos);

          // TODO: remove and test MobxUtils
          props.updateCategories(cloneDeep(MobxUtils.toJS(store.model.copyReportCategoryList)));
        })
      );
    },

    renderContainer: function() {
      var props = this.props;
      var localization = props.localization;
      var boardDetail = props.boardDetail;
      var type = boardDetail.type;
      var notifyChange = EventsUtils.notifyChange;
      var disableSubCategory = isEmpty(props.category);
      var authorization = props.authorization;

      var permissionKeys = props.authorizationConstants.PERMISSION_KEY;
      var hasPrivilege = authorization.checkPrivileges([permissionKeys.ReportsCanCreateNewCategoryValue]);

      var addNewCategory = notifyChange(props.addNewCategory);
      var noResultsTextCategory = constants.COPY_REPORT.TEXT_CREATE_CATEGORY;
      var addNewSubCategory = notifyChange(props.addNewSubCategory);
      var noResultsTextSubCategory = constants.COPY_REPORT.TEXT_CREATE_SUB_CATEGORY;

      if (!hasPrivilege) {
        addNewCategory = preventAddNew;
        noResultsTextCategory = null;
        addNewSubCategory = preventAddNew;
        noResultsTextSubCategory = null;
      }

      var actionContent = props.isMoveReport
        ? constants.ACTION_TYPES.MOVE_CONTENT
        : constants.ACTION_TYPES.COPY_CONTENT;

      return (
        <GridLayout className="form-horizontal">
          <GridLayout.Row>
            <GridLayout.Col cols="12">
              <p aria-label="text">
                {String.format(localization.getText('REPORTDESIGNER_LABEL_SPECIFY_DESTINATION'), actionContent)} &nbsp;
                <span className="text-lowercase">{props.typeName}</span>
              </p>
            </GridLayout.Col>
          </GridLayout.Row>

          {/* Report name*/}
          <GridLayout.Row>
            <GridLayout.Col cols="3">
              <Label className="control-label u_textNormal">
                {props.typeName} {localization.getText('COMMON_LABEL_NAME')}
              </Label>
            </GridLayout.Col>
            <GridLayout.Col cols="9">
              <ValidatableInput
                value={props.reportName}
                className="form-control custom-input-name"
                onChange={notifyChange(props.handleChangeReportName, EventsUtils.INPUT)}
                validations={
                  type == constants.CATEGORY_TYPE.REPORT
                    ? constants.CONSTRAINTS.NAME
                    : constants.CONSTRAINTS.TEMPLATE_NAME
                }
                field="Name"
                type="text"
                autoFocus
              />
            </GridLayout.Col>
          </GridLayout.Row>

          {/* save into only visible for user system admin in system mode.*/}
          {props.hiddenSaveintos && (
            <GridLayout.Row>
              <GridLayout.Col cols="3">
                <Label className="control-label u_textNormal">{localization.getText('COMMON_LABEL_SAVE_INTO')}</Label>
              </GridLayout.Col>
              <GridLayout.Col cols="9">
                <Dropdown
                  valueField="value"
                  labelField="name"
                  value={props.saveInto}
                  onChange={props.onChangeSaveInto}
                  options={props.saveIntos}
                />
              </GridLayout.Col>
            </GridLayout.Row>
          )}
          {/* Category name*/}
          <GridLayout.Row>
            <GridLayout.Col cols="3">
              <Label className="control-label u_textNormal">{localization.getText('COMMON_LABEL_CATEGORY')}</Label>
            </GridLayout.Col>
            <GridLayout.Col cols="9">
              <Select
                simpleValue
                options={props.categories}
                labelKey="name"
                valueKey="id"
                value={props.category}
                noResultsText={noResultsTextCategory}
                onChange={props.updateCategory}
                onAddNew={addNewCategory}
                scalable={false}
              />
            </GridLayout.Col>
          </GridLayout.Row>

          {/* Subcategory name*/}
          <GridLayout.Row>
            <GridLayout.Col cols="3">
              <Label className="control-label u_textNormal">{localization.getText('COMMON_LABEL_SUBCATEGORY')}</Label>
            </GridLayout.Col>
            <GridLayout.Col cols="9">
              <Select
                simpleValue
                options={props.subCategories}
                labelKey="name"
                valueKey="id"
                value={props.subCategory}
                noResultsText={noResultsTextSubCategory}
                onChange={props.updateSubCategory}
                onAddNew={addNewSubCategory}
                disabled={disableSubCategory}
                scalable={false}
              />
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      );
    },

    render: function() {
      var props = this.props;
      var localization = props.localization;

      var typeAction = props.isMoveReport ? constants.ACTION_TYPES.MOVE_TITLE : constants.ACTION_TYPES.COPY_TITTLE;

      return (
        <Popup visible onClosing={props.onClosing} autoClose={false} type="none">
          <Popup.Header title={typeAction + props.typeName} />
          <Popup.Body>{this.renderContainer()}</Popup.Body>
          <Popup.Footer>
            <Popup.ConfirmationButton type="accept">{localization.getText('COMMON_LABEL_OK')}</Popup.ConfirmationButton>
            <Popup.ConfirmationButton type="cancel">
              {localization.getText('COMMON_LABEL_CANCEL')}
            </Popup.ConfirmationButton>
          </Popup.Footer>
        </Popup>
      );
    }
  });

  module.exports = connect(action)(CopyReport);
  module.exports.$popupName = 'CopyReport';
})();



// WEBPACK FOOTER //
// ./ui/modules/Reports/ReportList/CopyReport/Izenda.CopyReport.jsx